var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-layout"},[(_vm.loading)?_c('loading-indicator',{attrs:{"title":_vm.loadingTitle,"content":_vm.loadingSubtitle}}):_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }